<template>
<el-container>
  <el-main>
   <el-dialog
      title="添加楼栋"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="addBuildingVisible"
      width="400px"
    >
    <el-form
      :inline="true"
      :model="addBuildingForm"
      ref="addBuildingForm"
      class="demo-ruleForm"
    >
    <el-form-item
      label="楼栋名称"
      label-width="120px"
    >
       <el-input type="text" v-model="addBuildingForm.buildingName" placeholder=""  style="width: 200px" show-word-limit></el-input>   
    </el-form-item>
    <el-form-item
      label="楼栋性质"
      label-width="120px"
    >
     <el-select v-model="addBuildingForm.sort" placeholder="请选择">
       <el-option
       v-for="item in sortOptions"
       :key="item.value"
       :label="item.label"
       :value="item.value">
      </el-option>
     </el-select>
    </el-form-item>
    </el-form>
    <div style="margin-top: 10px">
      <el-button type="primary" @click="confirmAddBuilding">{{$t("apartmentRoomDetail.confirm")}}</el-button>
      <el-button type="primary" @click="addBuildingVisible = false;">{{ $t("apartmentRoomDetail.cancel") }}</el-button>
    </div>
   </el-dialog>
  <el-form :inline="true" class="demo-form-inline">
       <el-form-item :label="$t('roomList.apartment')">
        <el-select v-model="selectForm.apartmentId" filterable @change="apartmentSelectChange" :placeholder="$t('roomList.choose')">
          <el-option
           v-for="item in apartmentOptions"
           :key="item.apartmentId"
           :label="item.apartmentName"
           :value="item.apartmentId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="楼栋名称">
         <el-input v-model="selectForm.buildingName" prefix-icon="el-icon-search" placeholder="请输入楼栋名称"></el-input>
      </el-form-item>
      <el-form-item >
        <el-button type="primary"  icon="el-icon-search" @click="onSelectBuildingList">搜索</el-button>
      </el-form-item>
      <el-form-item >
       <el-button type="primary" icon="el-icon-plus" @click="addBuilding">添加楼栋</el-button>
      </el-form-item> 
  </el-form>
  <el-table
    :data="pageData.buildingData"
    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    empty-text="No Data"
    border
    style="margin-top: 5px"
   >
    <el-table-column
      type="index"
      label="序号"
      width="50">
    </el-table-column>
    <el-table-column
    prop="buildingName"
    label="楼栋名称">
    </el-table-column>

    <el-table-column
    prop="buildingNo"
    label="楼栋编号">
    </el-table-column>

    <el-table-column
     prop="floorCount"
     label="楼层个数">
    </el-table-column>

    <el-table-column
    prop="sort"
    label="楼栋性质">
    <template slot-scope="scope">
        {{scope.row.sort==0?"混合楼":scope.row.sort==1?"男生楼":scope.row.sort==2?"女生楼":""}}
    </template>
    </el-table-column>
     
   <el-table-column
      prop
      label="操作"
      width="220"
      align="center"
    >
      <template slot-scope="scope">
        <el-button
          type="primary"
          size="mini"
          @click="editBuilding(scope.$index, scope.row)"
        >编辑</el-button>
        <el-button
          type="primary"
          size="mini"
          @click="buildingDetail(scope.$index, scope.row)"
        >楼层</el-button>
        <el-button
          type="danger"
          size="mini"
          @click="deleteBuilding(scope.$index, scope.row)"
        >删除</el-button>
      </template>
    </el-table-column>

    </el-table>

    <el-footer>
      <div>
        <Pagings
        :total="pageData.total"
        :offset="pageData.offset"
        :pageSize="pageData.pageNumber"
        @handleSizeChangeSub="buildingHandleSizeChange"
        @handleCurrentChangeSub="buildingHandleCurrentChange">
        </Pagings>
      </div>
    </el-footer> 
  </el-main>
</el-container>      
</template>

<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "buildingList",
  props: ['searchVal'],//父页传过来的schoolId
  data() {
     return {
        opFlag:true,
        addBuildingVisible:false,
        pageData:{
         offset: 1,
         pageNumber: 10,
         total: 0, //总条数
         buildingData: [],
        },
        selectForm:{
          apartmentId:"",
          apartmentType:1,
          buildingName:"",
        },
        apartmentOptions:[],
        addBuildingForm:{
          buildingId:"",
          buildingName:"",
          sort:""
        },
        sortOptions:[{
          value: '0',
          label: '混合楼'
        }, {
          value: '1',
          label: '男生楼'
        }, {
          value: '2',
          label: '女生楼'
        }],
     }      
  },
  components: {
    Pagings
  },
  watch: {
    searchVal: function (val) { 
     this.$store.state.schoolId=val; 
     this.buildingPower(this.$store.state.schoolId);
    }
  },
  mounted() {

//    if(this.$store.state.schoolId!=""&&this.$store.state.schoolId!=null){
//      this.buildingPower(this.$store.state.schoolId);
//    }  
      this.getApartmentList();
  },  
  methods: {
    //删除楼栋
    deleteBuilding(index,row){
      this.$confirm("您确定楼栋么？",this.$t("tenant.hint"), {
          confirmButtonText: this.$t("tenant.confirm"),
          cancelButtonText: this.$t("tenant.cancel"),
          type: 'warning'
      }).then(() => {
        var formData = new FormData();
        formData.append("buildingId",row.buildingId);
        this.$server
        .exam("/customer/apartment/deleteBuilding", formData)
        .then(data => {
         if (data.code == 200) {
          this.buildingPower(this.$store.state.schoolId);
          this.$message({
            message: data.message,
            type: "success"
          });
          } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
         }
      });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t("tenant.cancelDelete")
        });          
      });  

    },
    //打开编辑楼层信息
    editBuilding(index,row){
      this.opFlag=false;
      this.addBuildingVisible=true;
      this.addBuildingForm.buildingName=row.buildingName;
      this.addBuildingForm.sort=row.sort+"";
      this.addBuildingForm.buildingId=row.buildingId;
    },
    //楼栋详细
    buildingDetail(index, row) {
      var buildingData=JSON.stringify(row);
      // alert(JSON.stringify(buildingData));
      this.$router.push({path: "/buildingDetail",query: {apartmentId:this.selectForm.apartmentId,apartmentType:this.selectForm.apartmentType,buildingData:buildingData}});
    },
    //搜索楼栋列表
    onSelectBuildingList(){
      this.buildingPower(this.$store.state.schoolId);
    },
    //增加楼栋
    confirmAddBuilding(){
      var buildingName=this.addBuildingForm.buildingName;
      var sort=this.addBuildingForm.sort;
      if(buildingName==""||buildingName==null){
          this.$message({
            message:"楼栋名称不能为空",
            type: "warning"
          });
          return false;
      }
      if(sort==""||sort==null){
         this.$message({
            message:"请选择楼栋性质",
            type: "warning"
          });
          return false;
      }
     var formData = new FormData();
    
     if(this.opFlag){
        formData.append("apartmentId", this.$store.state.schoolId);
        formData.append("buildingName", this.addBuildingForm.buildingName);
        formData.append("sort", this.addBuildingForm.sort);
        this.$server
        .exam("/customer/apartment/addApartmentBuilding", formData)
        .then(data => {
        if (data.code == 200) {
          this.addBuildingVisible=false;
          this.buildingPower(this.$store.state.schoolId);
          this.$message({
            message: data.message,
            type: "success"
          });
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
     }else{
       formData.append("buildingId", this.addBuildingForm.buildingId);
       formData.append("buildingName", this.addBuildingForm.buildingName);
       formData.append("sort", this.addBuildingForm.sort);
       this.$server
        .exam("/customer/apartment/editBuilding", formData)
        .then(data => {
         if (data.code == 200) {
          this.addBuildingVisible=false;
          this.buildingPower(this.$store.state.schoolId);
          this.$message({
            message: "编辑楼栋信息成功",
            type: "success"
          });
          } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
         }
      });
     }
      
    },
    //新增楼栋
    addBuilding(){
     this.opFlag=true;
     this.addBuildingVisible=true;
     this.addBuildingForm.buildingName="";
     this.addBuildingForm.sort="";
     this.addBuildingForm.buildingId="";
    },
    //查询租客
    onSelect(){
      this.buildingPower();
    },

    // getSchoolList(){
    //       var formData = new FormData();
    //       this.$server
    //       .exam("/customer/apartment/listOwnerApartment", formData)
    //       .then(data => {
    //        if (data.code == 200) {
    //            this.schoolOptions=data.data;
    //            if(data.data.length>0){
    //               this.selectForm.schoolId=data.data[0].apartmentId;
    //               this.buildingPower(data.data[0].apartmentId);
    //            }
               
    //         } else {
    //           this.$message({
    //            message: data.message,
    //            type: "warning"
    //           });
    //         }
    //      });
    // },

     //公寓改变值事件
    apartmentSelectChange(row){
      this.selectForm.apartmentId=row;
      //  alert(JSON.stringify(row));  
    },

    getApartmentList(){
      var formData = new FormData();
      this.$server
      .exam("/customer/apartment/listOwnerApartment", formData)
      .then(data => {
        if (data.code == 200) {
          this.apartmentOptions=data.data;
          if(data.data.length>0){
            if(this.$route.query.apartmentId!=undefined&&this.$route.query.apartmentId!=""&&this.$route.query.apartmentId!=null){
               this.selectForm.apartmentId=this.$route.query.apartmentId;
               this.buildingPower(this.$route.query.apartmentId);
            }else{
               this.selectForm.apartmentId=data.data[0].apartmentId;
               this.buildingPower(data.data[0].apartmentId);
            }
          }
               
        } else {
          this.$message({
            message: data.message,
            type: "warning"
          });
        }
      });
    },
   
    buildingPower(apartmentId){
          var buildingName=this.selectForm.buildingName;
          var formData = new FormData();
          if(buildingName!=""&&buildingName!=null){
             formData.append("buildingName",apartmentId);
          }
          formData.append("apartmentId",apartmentId);
          formData.append("pageNo", this.pageData.offset);
          formData.append("pageSize", this.pageData.pageNumber);
          this.$server
          .exam("/customer/apartment/listBuildings", formData)
          .then(data => {
           if (data.code == 200) {
             console.log(data.data);
             this.pageData.buildingData = data.data.records;
             this.pageData.total = data.data.total;
            } else {
              this.$message({
               message: data.message,
               type: "warning"
              });
            }
         });
       },
     buildingHandleSizeChange(val) {
       this.pageData.pageNumber = val;
       this.buildingPower();
     },
     buildingHandleCurrentChange(val) {
       this.pageData.offset = val;
       this.buildingPower();
     },

  }    
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/building/buildingList.vue